// src/web/client/src/utils/dashboardLoad.js
//
// Pure state transitions for the dashboard's load lifecycle.
//
// The invariant this file exists to protect (B5): A FAILED LOAD NEVER
// DESTROYS DATA ALREADY ON SCREEN. The previous implementation fabricated
// zeroed stats inside the catch — so a one-second network blip during the
// 60-second auto-refresh replaced a merchant's live revenue number with $0
// and rendered the "empty store" welcome. Trust-first means: on failure,
// keep the last loaded data and surface an honest "couldn't refresh" notice.
//
// Kept as a pure reducer (no React, no fetch) so the invariant is unit-
// testable without a browser — see utils/__tests__/dashboardLoad.test.js.

export const initialLoadState = {
  data: null, // last successfully-loaded dashboard payload (normalized)
  error: null, // message of the most recent failure, or null
};

export function dashboardLoadReducer(state, action) {
  switch (action.type) {
    case 'loaded':
      // Fresh data replaces old; any prior failure notice clears.
      return { data: action.data, error: null };
    case 'failed':
      // THE invariant: previous data survives the failure untouched.
      return { data: state.data, error: action.error || 'Failed to load dashboard data' };
    default:
      return state;
  }
}
